<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__memberbalancecharge">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberMobile" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.transferMemberMobile" placeholder="转账用户电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="orgName" label="所属区域" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberMobile" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="name" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="amount" label="转账金额" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="transferMemberName" label="转账会员名称" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="transferMobile" label="转账会员电话号" header-align="center"
                                 align="center"></el-table-column>
               <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="operator" label="操作者" header-align="center" align="center"></el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                visible: false,
                orgList: [],
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/transfer/page',
                    getDataListIsPage: true,
                    deleteIsBatch: false,
                    activatedIsNeed: false
                },
                dataForm: {
                    mobileNumber: '',
                    transferMemberMobile: '',
                    beginDate: "",
                    endDate: "",
                    orgId: '',
                    orgName:'',
                    isHead:false
                }
            }
        },
        created() {
            let d = new Date
            //d.setTime(d.getTime()-24*30*60*60*1000);
            d.setMonth(d.getMonth()-1);
            this.dataForm.beginDate=d
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        methods:{
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            }
        },
    }
</script>
